import PropTypes from 'prop-types';
import { lazy } from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
// import LoadingScreen from 'src/components/LoadingScreen';
//* Components
const LoadingScreen = lazy(() => import('src/components/LoadingScreen.jsx'));
import { OKTA_LOGIN_PAGE } from 'src/context/auth/types';
import useAuth from 'src/hooks/useAuth';
import IdentityHelper from 'src/utilities/IdentityHelper';
// hooks
// import useAuth from "../hooks/useAuth";
// pages
// components

// ----------------------------------------------------------------------

export default function ContactCenterAuthGuard({ children }) {
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const authDataset = useAuth();
  const { setAuthenticationDetails, getOktaAccessToken } = { ...authDataset };

  const redirectToOktaLogin = () => {
    window.location.href = OKTA_LOGIN_PAGE;
  };

  //TODO: REMOVE BEFORE RELEASE
  //* TODO: isDev PRE-DEPLOY
  const isDev = false;
  //* Safeguard to ensure we never go to any other environments in dev mode.
  // const isDeveAndDevMode = import.meta.env.MODE === 'localdev' ? isDev : false;

  const isDevAndDevMode = import.meta.env.MODE === 'localdev' ? true : false;

  useEffect(() => {
    async function initialize() {
      try {
        //TODO: REMOVE BEFORE RELEASE
        if (isDev === true) {
          setIsAuthenticated(true);
          setIsInitialLoading(false);
          // update the value in the context store so that other age can have access to it.
          setAuthenticationDetails(true);
          return;
        }
        //TODO: REMOVE BEFORE RELEASE

        IdentityHelper.initOktaConfig();
        let oktaClient = IdentityHelper.getOktaAuthClient();
        let sessionExist = await oktaClient.session.exists();
        if (sessionExist) {
          let oktaAccessToken = await getOktaAccessToken();
          if (oktaAccessToken) {
            setIsAuthenticated(true);
            setIsInitialLoading(false);
            // update the value in the context store so that other age can have access to it.
            setAuthenticationDetails(true);
          } else {
            setIsInitialLoading(false);
          }
        } else {
          // "The CC agent session does not exist, redirecting to the okta login page"
          setIsInitialLoading(false);
        }
      } catch (err) {
        console.error('Error occurred while calling Okta library - ', err);
      }
    }

    initialize();
  }, []);

  if (isInitialLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return redirectToOktaLogin();
  }
  return <>{children}</>;
}

ContactCenterAuthGuard.propTypes = {
  children: PropTypes.node,
};
